module.exports = __webpack_public_path__ + "media/houseWithCoupleInFront.47b74667.svg";